//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchInput from '@/components/search-input';
import qualityTp from '@/components/page-temporary/qualityTp'
export default {
  name: "quality-management-list",
  components: {searchInput,qualityTp},
  data() {
    return {
      wrapperHeight: 0,
      allLoaded: false,
      show:true,
      config: {
        title: '质量管理',
        url: 'api/quality-table-dt/page',
        workflowSearchBean: {},
        tabList: [],
        property: "id",
        inputCondition: {
          placeholder: '物料编号/名称',
          searchCondition: 'key',
          rules: [{field: "material.matName-material.matCode", option: "LIKE_ANYWHERE"}]
        },
        selectConfig: [
          {
            text: '检验状态',
            type: 'selector',
            list:[{name:'全部',code:''},{name:'合格',code:'QUALIFIED'},{name:'让步接受',code:'CONCESSION'},{name:'不合格',code:'DISQUALIFIED'}],
            rules: [{field: "testStatus", option: "IN"}],
          },
          {
            text: '检验类型',
            type: 'selector',
            list:[{name:'全部',code:''},{name:'入库检验',code:'STOCK_CHECK'},{name:'过程检验',code:'PROCESS_CHECK'},{name:'客户发现',code:'CUS_DISC'},{name:'其他',code:'OTHER'}],
            rules: [{field: "qualityTable.testType", option: "IN"}],
          },
          {
            text: '检验时间',
            type: 'date',
            isOld:true,
            rules:[{field: "qualityTable.testDate",collectIndex: -1,option: "BTD"}],
          }
        ]
      },
      searchData: {},
      list: [],
      showMore: true
    }
  },
  methods: {
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    goDetail(id){
       this.$router.push('/quality-management-view/'+id)
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop() {
      this.$refs.header.getlist(true);
    },
    loadBottom() {
      this.$refs.header.getMore();
    }
  },
  mounted() {
    this.init();
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/quality-management/quality-management-list.vue